// Home page colors
export const NAV_BAR_COLOR = '#F1D0BC';
export const BACKGROUND_COLOR = '#A5ACB4';
export const BOX_BG_COLOR = 'white';
export const DARK_BOX_BG_COLOR = '#505C66';
export const LIGHT_TEXT_COLOR = 'white';
export const DARK_TEXT_COLOR = '#333333';
export const BORDER_COLOR = 'gray.800';
export const BORDER_RADIUS = '6px';
export const GHOST_GREY_PRIMARY = '#1f242b';
export const GHOST_GREY_SECONDARY = '#13171c';
